(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductBreadcrumbs', () => ({
      init() {
        let am = this;
        let cache = JSON.parse(am.$el.dataset.cache)
        let template = am.$el.dataset.template
        let SESSION_KEY = 'ProductBreadcrumbs'
        if (template.indexOf('product') !== -1) {
          if (cache) {
            sessionStorage.setItem(SESSION_KEY, am.$el.innerHTML)
          }
          else {
            am.$el.innerHTML = sessionStorage.getItem(SESSION_KEY)
          }  
        }
        else {
          sessionStorage.removeItem(SESSION_KEY)
        }
      }
    }))
  })
})();